(function () {
  function updateCompareCard(select) {
    const option = select.options[select.selectedIndex];
    const card = select.closest('.nova-compare-card');

    if (!option || !card) return;

    const image = card.querySelector('img');
    const form = card.querySelector('.nova-compare-form');
    const variantInput = card.querySelector('[data-nova-compare-variant]');
    const buyButton = card.querySelector('[data-nova-compare-buy]');
    const learnLink = card.querySelector('[data-nova-compare-learn]');
    const isAvailable = option.dataset.available === 'true';

    if (image && option.dataset.image) {
      image.src = option.dataset.image;
      image.removeAttribute('srcset');
      image.alt = option.textContent.trim();
    }

    if (variantInput && option.dataset.variantId) {
      variantInput.value = option.dataset.variantId;
    }

    if (form) {
      form.hidden = !isAvailable;
    }

    if (buyButton) {
      buyButton.disabled = !isAvailable;
    }

    if (learnLink && option.dataset.url) {
      learnLink.href = option.dataset.url;
    }

    const section = select.closest('.nova-compare-section');
    syncCompareOptions(section);
    updateCompareSpecs(section);
  }

  function updateCompareSpecs(section) {
    if (!(section instanceof HTMLElement)) return;

    const data = section.querySelector('[data-nova-compare-products]');
    const table = section.querySelector('[data-nova-compare-table]');
    const selects = Array.from(section.querySelectorAll('[data-nova-compare-select]'));
    const fixedHandles = Array.from(section.querySelectorAll('[data-nova-compare-fixed]')).map((element) => element.dataset.novaCompareFixed);
    const selectedHandles = [
      ...fixedHandles,
      ...selects.map((select) => select.value),
    ].filter(Boolean);
    if (!(data instanceof HTMLScriptElement) || !(table instanceof HTMLElement) || selectedHandles.length < 2) return;

    let products;
    try {
      products = JSON.parse(data.textContent || '[]');
    } catch {
      return;
    }

    const selectedProducts = selectedHandles.map((handle) => products.find((product) => product.handle === handle));
    const specTitles = [];
    selectedProducts.forEach((product) => {
      product?.specs?.forEach((spec) => {
        if (spec?.title && !specTitles.includes(spec.title)) specTitles.push(spec.title);
      });
    });

    table.replaceChildren(
      ...specTitles.map((title) => {
        const row = document.createElement('div');
        row.className = 'nova-compare-row';

        const label = document.createElement('strong');
        label.textContent = title;
        const values = document.createElement('div');
        values.className = 'nova-compare-values';

        selectedProducts.forEach((product) => {
          const value = document.createElement('span');
          const spec = product?.specs?.find((item) => item.title === title);
          if (spec?.contentRich) {
            value.innerHTML = spec.contentRich;
          } else {
            value.textContent = spec?.content || '-';
          }
          values.append(value);
        });

        row.append(label, values);
        return row;
      })
    );
  }

  function syncCompareOptions(section) {
    if (!(section instanceof HTMLElement)) return;

    const selects = Array.from(section.querySelectorAll('[data-nova-compare-select]'));
    const fixedHandles = Array.from(section.querySelectorAll('[data-nova-compare-fixed]')).map((element) => element.dataset.novaCompareFixed);

    selects.forEach((select) => {
      const selectedElsewhere = [
        ...fixedHandles,
        ...selects.filter((otherSelect) => otherSelect !== select).map((otherSelect) => otherSelect.value),
      ];

      Array.from(select.options).forEach((option) => {
        option.disabled = selectedElsewhere.includes(option.value);
      });
    });
  }

  function initCompareSelectors() {
    document.querySelectorAll('[data-nova-compare-select]').forEach((select) => {
      if (!(select instanceof HTMLSelectElement) || select.dataset.novaCompareReady) return;

      select.dataset.novaCompareReady = 'true';
      select.addEventListener('change', () => updateCompareCard(select));
      const section = select.closest('.nova-compare-section');
      syncCompareOptions(section);
      updateCompareSpecs(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCompareSelectors, { once: true });
  } else {
    initCompareSelectors();
  }

  document.addEventListener('shopify:section:load', initCompareSelectors);
})();
